export default __webpack_public_path__ + "img/9fe33868363e03945c0544c7c973792e.svg";